var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolve(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47.125,
    height: 40.479,
    viewBox: "0 0 47.125 40.479",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -35.047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.177,54.326,115,52.5a.993.993,0,0,1,1.644.39,3.475,3.475,0,1,0,4.4-4.409.992.992,0,0,1-.385-1.642l1.044-1.044.783-.783a.861.861,0,0,0,0-1.218l-8.167-8.167a1.986,1.986,0,0,0-2.808,0l-9.127,9.127,2.944,7.016,7.236,3.164Z",
    transform: "translate(-92.68)",
    fill: "#dca5cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.483,37.788l-2.159-2.159a1.986,1.986,0,0,0-2.808,0l-9.127,9.127,4.573,4.573A19.944,19.944,0,0,1,116.483,37.788Z",
    transform: "translate(-92.681 -0.001)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.048,142.573a3.475,3.475,0,1,0-4.629-4.641.994.994,0,0,1-1.6.28L9.708,136.1.581,145.227a1.986,1.986,0,0,0,0,2.808l8.776,8.776,6.391-3.948,4.14-6.583-2.111-2.111a.991.991,0,0,1,.272-1.6Z",
    transform: "translate(0 -91.345)",
    fill: "#dca5cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.475,135.971a3.478,3.478,0,0,0-3.055,1.97.994.994,0,0,1-1.6.28L9.708,136.11.581,145.237a1.986,1.986,0,0,0,0,2.808l8.776,8.776,4.762-4.762a19.937,19.937,0,0,1,2.355-16.087Z",
    transform: "translate(0 -91.355)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.1,249.712a.991.991,0,0,0-1.6.272,3.475,3.475,0,1,1-4.635-4.632.992.992,0,0,0,.274-1.6l-1.936-1.936-2.436,2.436a.994.994,0,0,1-1.645-.392,3.471,3.471,0,0,0-1.029-1.521,3.429,3.429,0,0,0-1.4-.726,3.474,3.474,0,0,0-1.973,6.658.992.992,0,0,1,.385,1.642l-2.435,2.435,9.478,9.478a1.986,1.986,0,0,0,2.808,0l2.159-2.159,6.13-6.13a1.185,1.185,0,0,0,0-1.675Z",
    transform: "translate(-86.314 -186.884)",
    fill: "#dca5cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7,241.615a3.474,3.474,0,0,0-1.973,6.658.992.992,0,0,1,.385,1.642l-2.435,2.435,9.478,9.478a1.986,1.986,0,0,0,2.808,0l2.159-2.159A19.887,19.887,0,0,1,99.7,241.615Z",
    transform: "translate(-86.315 -186.884)",
    fill: "#0593ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,139.634H335.557a.861.861,0,0,0-.861.861v2.583a.992.992,0,0,0,1.433.889,3.476,3.476,0,1,1,.008,6.23.994.994,0,0,0-1.441.885v2.583a.861.861,0,0,0,.861.861h1.865a1,1,0,0,1,.95,1.316,3.475,3.475,0,1,0,6.556.022,1,1,0,0,1,.93-1.338h2.252a1.975,1.975,0,0,0,1.975-1.975V141.62A1.986,1.986,0,0,0,348.1,139.634Z",
    transform: "translate(-302.961 -94.67)",
    fill: "#dca5cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.557,139.634a.861.861,0,0,0-.861.861v2.583a.992.992,0,0,0,1.433.889,3.453,3.453,0,0,1,3.627.334,16.018,16.018,0,0,1,1.4-4.668Z",
    transform: "translate(-302.961 -94.67)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.909,246.183a3.454,3.454,0,0,1-3.771.461.994.994,0,0,0-1.441.885v2.583a.861.861,0,0,0,.861.861h1.865a1,1,0,0,1,.95,1.316,3.475,3.475,0,0,0,6.439,2.6A16.107,16.107,0,0,1,339.909,246.183Z",
    transform: "translate(-302.962 -191.117)",
    fill: "#1487eb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.764 39.032)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M189.232,77.284a.711.711,0,0,0-1.006,0l-.67.67a.711.711,0,1,0,1.006,1.006l.67-.67A.711.711,0,0,0,189.232,77.284Z",
    transform: "translate(-187.347 -77.075)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.7,143.752a.711.711,0,0,0-1.006,0l-.671.67a.711.711,0,0,0,1.006,1.006l.671-.67A.711.711,0,0,0,255.7,143.752Z",
    transform: "translate(-247.513 -137.241)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.676,107.624a.711.711,0,0,0-.907-.434.977.977,0,0,1-1.238-1.238.711.711,0,1,0-1.341-.474,2.4,2.4,0,0,0,3.053,3.053A.711.711,0,0,0,213.676,107.624Z",
    transform: "translate(-207.903 -102.356)",
    fill: "#e4e4e4"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M155.875,326.595a.711.711,0,0,0-1.006,0l-.67.67a.711.711,0,1,0,1.006,1.006l.67-.67A.711.711,0,0,0,155.875,326.595Z",
    transform: "translate(-139.389 -263.715)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.343,393.063a.711.711,0,0,0-1.006,0l-.67.67a.711.711,0,0,0,1.006,1.006l.67-.67A.711.711,0,0,0,222.343,393.063Z",
    transform: "translate(-199.555 -323.881)",
    fill: "#e4e4e4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.32,356.935a.711.711,0,0,0-.907-.434.977.977,0,0,1-1.238-1.238.711.711,0,1,0-1.341-.473,2.4,2.4,0,0,0,3.053,3.053A.711.711,0,0,0,180.32,356.935Z",
    transform: "translate(-159.946 -288.996)",
    fill: "#e4e4e4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolve);
export default __webpack_public_path__ + "static/media/solve.92da43f0d86225980f861f87f1d3d40f.svg";
export { ForwardRef as ReactComponent };